import { createSlice } from "@reduxjs/toolkit";

/**
 * Initial state for the user slice.
 * @typedef {Object} UserState
 * @property {Object|null} user - Logged-in user object
 * @property {"idle"|"loading"|"succeeded"|"failed"} status - Loading status
 * @property {string|null} error - Error message if any
 */

const initialState = {
  user: null,
  status: "idle",
  error: null,
};

/**
 * Redux slice for managing user information and status.
 */

const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    /**
     * Set the user data after successful fetch or login.
     * @param {UserState} state
     * @param {{payload: Object}} action
     */
    setUser: (state, action) => {
      state.user = action.payload;
      state.status = "succeeded";
      state.error = null;
    },
    /**
     * Clear the user state, e.g., on logout.
     * @param {UserState} state
     */
    clearUser: (state) => {
      state.user = null;
      state.status = "idle";
      state.error = null;
    },
    /**
     * Set an error and update status to failed.
     * @param {UserState} state
     * @param {{payload: string}} action
     */
    setError: (state, action) => {
      state.error = action.payload;
      state.status = "failed";
    },
    /**
     * Set loading state while data is being fetched.
     * @param {UserState} state
     */
    setLoading: (state) => {
      state.status = "loading";
    },
  },
});

export const { setUser, clearUser, setError, setLoading } = userSlice.actions;
export default userSlice.reducer;
